import { useMemo, useState } from 'react';
import { CardHolding } from "./components/utils/CardHolding";
import { GetBankBalanceDataHolding, GetDashboardCardsHolding, GetPendingPaymentDashboardHolding, GetPendingToPayDashboardHolding, GetSII12MonthsPurchasesHolding, GetSII12MonthsSalesHolding, GetSIILast12MonthsPurchasesHolding, GetSIILast12MonthsSalesHolding } from 'src/graphql/holding';
import { formatMoneyWithCurrency } from 'src/utils/formatter';
import moment from 'moment';
import { VentasNetas } from './components/VentasNetas';
import { ComprasNetas } from './components/ComprasNetas';
import { PorCobrar } from './components/PorCobrar';
import { PorPagar } from './components/PorPagar';
import { Saldos } from './components/Saldos';

export const DashboardHolding = ({ selectedCompanies }) => {

  const [period, setPeriod] = useState("year");
  const [specificPeriods, setSpecificPeriods] = useState("");

  const { data: Sales, reexecuteQuery: refetchSales, fetching: loadingSales } = GetSII12MonthsSalesHolding({ companyIds: selectedCompanies })
  const { data: LastSales, reexecuteQuery: refetchLastSales } = GetSIILast12MonthsSalesHolding({ companyIds: selectedCompanies })

  const { data: Purchases, reexecuteQuery: refetchPurchases, fetching: loadingPurchases } = GetSII12MonthsPurchasesHolding({ companyIds: selectedCompanies })
  const { data: LastPurchases, reexecuteQuery: refetchLastPurchases } = GetSIILast12MonthsPurchasesHolding({ companyIds: selectedCompanies })

  const { data: Cards, reexecuteQuery: refetchCards, fetching: loadingCards } = GetDashboardCardsHolding({ companyIds: selectedCompanies })

  const { data: PendingPayments, reexecuteQuery: refetchPendingPayments, fetching: loadingPendingPayments } = GetPendingPaymentDashboardHolding({ companyIds: selectedCompanies })
  const { data: ToPayPayments, reexecuteQuery: refetchToPayPayments, fetching: loadingToPayPayments } = GetPendingToPayDashboardHolding({ companyIds: selectedCompanies })

  const { data: Balances } = GetBankBalanceDataHolding({ companyIds: selectedCompanies });

  let currentMonthSales = 0;
  let totalSales = 0;
  let currentMonthPurchases = 0
  let totalPurchases = 0

  let bankAccountAmount = 0
  let toReceive = 0
  let toPay = 0

  if (Sales?.get12MonthsNetSalesHolding && Sales?.get12MonthsNetSalesHolding.length > 0) {
    const currentMonth = moment().month();
    const currentMonthSalesAllCompanies = Sales.get12MonthsNetSalesHolding
      .filter(sale => moment(sale.month).month() === currentMonth)
      .reduce((sum, sale) => sum + sale.sales, 0);

    currentMonthSales = formatMoneyWithCurrency(Math.round(currentMonthSalesAllCompanies * 1000000));

    totalSales = Math.round(Sales.get12MonthsNetSalesHolding
      .reduce((acc, el) => acc + el.sales, 0) * 1000000);
  }

  if (Purchases?.get12MonthsNetPurchasesHolding && Purchases?.get12MonthsNetPurchasesHolding.length > 0) {
    const currentMonth = moment().month()
    const currentMonthPurchasesAllCompanies = Purchases.get12MonthsNetPurchasesHolding
      .filter(purch => moment(purch.month).month() === currentMonth)
      .reduce((sum, purch) => sum + purch.sales, 0);

    currentMonthPurchases = formatMoneyWithCurrency(Math.round(currentMonthPurchasesAllCompanies * 1000000))
    totalPurchases = Math.round(Purchases?.get12MonthsNetPurchasesHolding.reduce((acc, el) => acc + el.sales, 0) * 1000000)
  }

  if (Cards?.dashboardCardsHolding) {
    bankAccountAmount = Cards?.dashboardCardsHolding?.bankAcountAmount || 0
    toReceive = Cards?.dashboardCardsHolding?.toReceive || 0
    toPay = Cards?.dashboardCardsHolding?.toPay || 0
  }

  const [activeTab, setActiveTab] = useState('venta');

  const cardTabs = [
    {
      id: 'venta',
      name: 'VENTAS NETAS',
      amount: totalSales || 0,
      component:
        <VentasNetas
          period={period}
          setPeriod={setPeriod}
          specificPeriods={specificPeriods}
          setSpecificPeriods={setSpecificPeriods}
          // loading={loadingSales}
          source={Sales?.get12MonthsNetSalesHolding}
          lastYear={LastSales?.getLast12MonthsNetSalesHolding} />
    },
    {
      id: 'compra',
      name: 'COMPRAS NETAS',
      amount: totalPurchases || 0,
      component:
        <ComprasNetas
          period={period}
          setPeriod={setPeriod}
          specificPeriods={specificPeriods}
          setSpecificPeriods={setSpecificPeriods}
          // loading={loadingSales}
          source={Purchases?.get12MonthsNetPurchasesHolding}
          lastYear={LastPurchases?.getLast12MonthsNetPurchasesHolding} />
    },
    {
      id: 'porCobrar',
      name: 'POR COBRAR',
      amount: toReceive || 0,
      component:
        <PorCobrar
          source={PendingPayments}
        // loading={loadingPendingPayments}
        />
    },
    {
      id: 'porPagar',
      name: 'POR PAGAR',
      amount: toPay || 0,
      component:
        <PorPagar
          source={ToPayPayments}
        // loading={loadingToPayPayments}
        />
    },

    {
      id: 'saldo',
      name: 'SALDO',
      amount: bankAccountAmount || 0,
      component:
        <Saldos
          source={Balances}
        />
    }
  ];

  const activeComponent = cardTabs.find(tab => tab.id === activeTab)?.component;

  return (
    <>
      {/* {
        selectedCompanies && selectedCompanies.length > 0 ?
          <> */}
            <p className="tw-text-xl tw-text-black tw-font-semibold" style={{ fontWeight: 600 }}>Dashboard</p>
            <div className="tw-flex tw-flex-wrap tw-gap-6 tw-w-full">
              {cardTabs.map((tab) => (
                <CardHolding
                  key={tab.id}
                  name={tab.name}
                  isActive={activeTab === tab.id}
                  amount={tab.amount}
                  onClick={() => setActiveTab(tab.id)}
                />
              ))}
            </div>
            <div className="tw-mt-6">
              {activeComponent}
            </div>
          </>
    //       :
    //       <div className='tw-flex-row tw-bg-white tw-rounded-md tw-p-7 tw-h-[70vh]'>
    //         SELECCIONE UNA EMPRESA DEL HOLDING AAAAAAAAAA
    //       </div>
    //   }
    // </>
  );
}